import {Edit, MoreVert} from "@mui/icons-material";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import React from "react";
import {Grey17, Grey6} from "../../theme/styles";
import css_self from "../Navigation/css/NavBar.module.scss";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";
import AdminUserGroupEmployeeFormApplet from "../../eoec/applet/impl/Administration/AdminUserGroupEmployeeFormApplet";

class AdminUserGroupEmployeeTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("admin-user-group-employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("admin-user-group-employee-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("admin-user-group-employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("admin-user-group-employee-form-applet-save", this.onCancelHandler);
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Employee") {
            this.setState({renderTarget: "New Employee"});
        } else if (identifier === "Disassociate Employee") {
            this.setState({renderTarget: "Disassociate Employee"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "New Employee") {
           return <AdminUserGroupEmployeeFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} availableModes={["Edit", "New", "View"]} defaultMode="New" />;
        } else if (this.state.renderTarget === "Disassociate Employee") {
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-9px", paddingLeft: "8px", marginRight: "auto", marginTop: "auto", marginBottom: "auto", height: "100%"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "EditUserGroup"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit UserGroup</Typography>
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(AdminUserGroupEmployeeTable)));